// packages/ui/src/components/settings/NodeSettings.tsx
// Node connection status and tool allowlists

export interface NodeInfo {
  id: string
  name: string
  status: 'connected' | 'disconnected'
  tools: string[]
}

interface NodeSettingsProps {
  nodes: NodeInfo[]
}

export function NodeSettings({ nodes }: NodeSettingsProps) {
  return (
    <div data-testid="settings-nodes" className="space-y-4">
      <h2 className="text-lg font-semibold text-gray-200 mb-3">Nodes</h2>
      <p className="text-sm text-gray-400 mb-4">
        Connected nodes and their available tools.
      </p>
      <div className="space-y-3">
        {nodes.map((node) => (
          <div
            key={node.id}
            className="p-4 rounded-lg bg-gray-800/50 space-y-2"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span
                  className={`w-2.5 h-2.5 rounded-full ${
                    node.status === 'connected' ? 'bg-green-500' : 'bg-red-500'
                  }`}
                />
                <span
                  data-testid={`node-name-${node.id}`}
                  className="text-sm font-medium text-gray-200"
                >
                  {node.name}
                </span>
              </div>
              <span
                data-testid={`node-status-${node.id}`}
                className={`text-xs px-2 py-0.5 rounded ${
                  node.status === 'connected'
                    ? 'text-green-400 bg-green-900/30'
                    : 'text-red-400 bg-red-900/30'
                }`}
              >
                {node.status}
              </span>
            </div>
            <div data-testid={`node-tools-${node.id}`} className="flex flex-wrap gap-1.5">
              {node.tools.map((tool) => (
                <span
                  key={tool}
                  className="text-xs font-mono text-gray-400 bg-gray-700 px-2 py-0.5 rounded"
                >
                  {tool}
                </span>
              ))}
              {node.tools.length === 0 && (
                <span className="text-xs text-gray-500">No tools registered</span>
              )}
            </div>
          </div>
        ))}
        {nodes.length === 0 && (
          <p className="text-sm text-gray-500">No nodes connected.</p>
        )}
      </div>
    </div>
  )
}
